<template>
  <nuxt-link
    class="button"
    v-bind="props"
    :class="{
      'router-link-exact-active-with-hash': linkExactActiveWithHash,
    }"
  >
    <span class="icon-value">
      <span class="icon"><slot name="icon" /></span>
      <span class="value">{{ value }}</span>
    </span>
    <span v-if="description" class="description">{{ description }}</span>
  </nuxt-link>
</template>
<script setup lang="ts">
interface Props {
  value: number;
  description?: string;
  to: string;
}
const props = defineProps({
  value: null,
  description: null,
  to: null
});

const route = useRoute();

const linkExactActiveWithHash = computed(() => {
  return toRef(props.to).value === route.fullPath;
});
</script>
<style lang="scss" scoped>
.icon-value {
  display: flex;
}
.icon {
  flex: 0 0 auto;
  width: 2.6rem;
  height: 2.6rem;
  :deep(svg),
  :deep(img) {
    width: auto;
    height: 100%;
  }
}
.value {
  @include font('m', 800, 'secondary');

  text-overflow: ellipsis;
}
.description {
  @include font('xxs', 400, 'secondary');

  /* Niveaux */
}
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: var(--gap_xs) var(--gap_xxs);
  border: var(--stroke_thickness_m) solid var(--color_secondary_lighter);
  border-radius: var(--stroke_radius_m);
  gap: var(--gap_xxs);
  @include hover-focus-desktop {
    transition: background-color 300ms $ease-out-quad;
    border: var(--stroke_thickness_m) solid var(--color_secondary_light);
    background-color: var(--color_secondary_lighter);
    .value,
    .description {
      color: var(--color_secondary);
    }
  }

  &.router-link-exact-active-with-hash {
    transition: background-color 300ms $ease-out-quad;
    border: var(--stroke_thickness_m) solid var(--color_secondary_light);
    background-color: var(--color_secondary_lighter);
    .value,
    .description {
      color: var(--color_secondary);
    }
  }
}
</style>
